import dateFormat from 'dateformat';

import {alternateDatesTransformDweb} from '@stencil/hotels-utils/src/date-utils/date-utils';
import useIsClient from '@stencil/hotels-hooks/src/useIsClient';

import AlternateDatesCardLoading from './AlternateDatesCardLoading';

import * as S from './AlternateDatesUI.styles';

const defaultSoldOutImageUrl =
  'https://go-assets.ibcdn.com/u/GI/images/1719385105210-sold-out-dt.png';

function AlternateDatesUI({
  data: alternateDatesData = [],
  isAlternateDatesLoading,
  propertyName,
  isAltacco,
  checkin,
  checkout,
  alternateDateHandler = (checkin, checkout) => {},
  handlRedirectToSRPGOSuggest = () => {},
}) {
  const isClient = useIsClient();

  const renderAlternateDate = () => {
    if (!(alternateDatesData && alternateDatesData.length)) {
      return (
        <S.ButtonWrapper onClick={handlRedirectToSRPGOSuggest}>
          View Similar Properties
        </S.ButtonWrapper>
      );
    }
    return (
      <>
        <S.PropertyAvailableText>Available dates:</S.PropertyAvailableText>
        <S.AvailableDateList>
          {alternateDatesData.map((item, index) => {
            const {dateString} = alternateDatesTransformDweb(item?.checkin, item?.checkout);
            return (
              <S.AvailableDateListItem
                onClick={() => alternateDateHandler(item?.checkin, item?.checkout)}
                key={index.toString()}
              >
                <S.DateRangeText>{dateString}</S.DateRangeText>
                <S.RoomPriceText>{`from ₹${item?.actualPrice}`}</S.RoomPriceText>
              </S.AvailableDateListItem>
            );
          })}
        </S.AvailableDateList>
      </>
    );
  };

  if (!isClient) {
    return null;
  }

  return (
    <S.SoldOutWrapper isVideo={!isAltacco}>
      <S.SoldOutDescWrapper>
        <S.ImageWrapper src={defaultSoldOutImageUrl} alt="Not Available" />
        <S.SoldOutDescText>
          <div>This Property is Sold Out on Goibibo from </div>
          <span>
            {dateFormat(checkin.date, 'dd mmm')} - {dateFormat(checkout.date, 'dd mmm')}
          </span>
        </S.SoldOutDescText>
        {isAlternateDatesLoading ? <AlternateDatesCardLoading /> : renderAlternateDate()}
      </S.SoldOutDescWrapper>
    </S.SoldOutWrapper>
  );
}

export default AlternateDatesUI;
